import { render, staticRenderFns } from "./AdvisorTemplate.vue?vue&type=template&id=396ca62e&"
import script from "./AdvisorTemplate.vue?vue&type=script&lang=js&"
export * from "./AdvisorTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports